import { createAppAsyncThunk } from "@src/store/hooks";
import { ApiProvider } from "@src/store/ApiProvider";
import {
	EventInventoryRecord,
	getInventoryCacheEventId,
	invalidateAllEventInventoryCache,
	queryEventInventoryAll,
	queryEventInventoryAllSlice,
} from "./queryEventInventoryAllSlice";
import { getGlobalInventoryParams, globalInventoryPathKey, queryGlobalInventory } from "./queryGlobalInventorySlice";
import { hiddenQueryEventsSlice } from "./queryEventsSlice";
import { PricingTabEnum } from "./selectionSlice";

export const invalidatePricingCaches = () => {
	invalidateAllEventInventoryCache();
	ApiProvider.default.removeCachePath(globalInventoryPathKey);
	ApiProvider.default.removeCachePath(hiddenQueryEventsSlice.name);
};

export const refreshPricingInventory = createAppAsyncThunk(
	"pricing/refreshPricingInventory",
	async (_arg: undefined, { dispatch, getState }) => {
		const state = getState();
		const companyName = state.settings.companyName;

		ApiProvider.default.removeCachePath(hiddenQueryEventsSlice.name);

		if (state.pricing.selection.pricingTab === PricingTabEnum.GlobalInventory) {
			invalidateAllEventInventoryCache();
			const searchString = new URLSearchParams(window.location.search).get("searchString")?.trim() ?? "";
			await dispatch(queryGlobalInventory(getGlobalInventoryParams(companyName, true, searchString)));
			return;
		}

		const eventId = state.pricing.selection.event?.Event_ID;
		if (!eventId) return;
		await dispatch(queryEventInventoryAll({ EventId: eventId, CompanyName: companyName, skipCache: true }));
	},
);

export const patchInventoryItems = createAppAsyncThunk(
	"pricing/patchInventoryItems",
	async (patches: Record<number, Partial<EventInventoryRecord>>, { dispatch, getState }) => {
		const state = getState();

		if (state.pricing.selection.pricingTab === PricingTabEnum.GlobalInventory) {
			await dispatch(refreshPricingInventory());
			return;
		}

		const data = state.pricing.eventInventoryAll.data.map((x) => (patches[x.Item_ID] ? { ...x, ...patches[x.Item_ID] } : x));
		dispatch(queryEventInventoryAllSlice.actions.updateInventoryAll({ data, eventId: getInventoryCacheEventId(state) }));
		ApiProvider.default.removeCachePath(globalInventoryPathKey);
	},
);
